// src/auth/canUseFeature.ts
// Pure predicate — deliberately free of react-admin so data-layer modules can
// import it without dragging the MUI/ra-ui-materialui ESM cascade into tests.
import type { KnownFeature, UserRole } from './roles';

export interface FeatureAccess {
    role: UserRole | undefined;
    features: string[];
    isPending: boolean;
}

// Single answer to "may this user use feature X", including the admin bypass
// that isAllowed() applies to routes. Call sites must not re-derive this with
// features.includes(), which misses the bypass.
export function canUseFeature(
    access: FeatureAccess,
    feature: KnownFeature
): boolean {
    if (access.isPending) return false;
    if (access.role === 'admin') return true;
    return access.features.includes(feature);
}
